import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import Loading from './Loading';
import './ViewReport.css';

const ViewReport = () => {
    const [activeTab, setActiveTab] = useState('assessment');
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMaximized, setIsMaximized] = useState(false);
    const [viewStatus, setViewStatus] = useState(null);

    useEffect(() => {
        // Get the status from session storage
        const status = sessionStorage.getItem('assessmentViewStatus');
        setViewStatus(status);

        if (status === 'InProgress') {
            setLoading(false);
            return;
        }

        // Get the stored assessment question answer data
        const storedData = sessionStorage.getItem('assessmentQuestionAnswer');
        if (storedData) {
            try {
                setReportData(storedData);
                setLoading(false);
            } catch (error) {
                console.error('Error setting report data:', error);
                setLoading(false);
            }
        }
    }, []);

    const sanitizeHtml = (html) => {
        if (!html) return { __html: '' };
        
        return {
            __html: DOMPurify.sanitize(html, {
                ALLOWED_TAGS: ['table', 'tr', 'td', 'th', 'tbody', 'thead', 'img', 'p', 'div', 'span', 'br', 'strong', 'b', 'i', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
                ALLOWED_ATTR: ['style', 'width', 'height', 'src', 'align', 'colspan', 'rowspan', 'class', 'id', 'border', 'cellpadding', 'cellspacing', 'bgcolor']
            })
        };
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="popup-container">
            <div className="popup-content">
                {viewStatus === 'InProgress' ? (
                    <div className="no-data-message">
                        <h2>No More Data Available in Archive to View the Report</h2>
                    </div>
                ) : (
                    <div className="view-report">
                        <div 
                            className="report-content"
                            dangerouslySetInnerHTML={sanitizeHtml(reportData)}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ViewReport;